import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { GroupCommunityType, GroupType } from 'types/groups';

const Container = styled.span`
  display: flex;
  flex-direction: column;
`;

const Count = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

interface Props {
  item: GroupType;
}

const GroupsTableCompany = ({ item }: Props) => {
  return (
    <Container>
      <Count>Total: {(item.communities ?? []).length}</Count>
      <Typography.Paragraph
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          fontSize: 10,
          color: 'var(--text-secondary)',
          marginBottom: 0,
        }}
        ellipsis={{
          rows: 3,
          expandable: 'collapsible',
          symbol: (expanded: boolean) => (
            <div style={{ display: 'flex', color: 'var(--dark-blue)', fontSize: 10 }}>
              {expanded ? 'Show Less' : 'Show More'}
            </div>
          ),
        }}
      >
        {(item?.communities ?? []).map((community: GroupCommunityType) => (
          <span key={community.id}>{community.comunity_name}</span>
        ))}
      </Typography.Paragraph>
    </Container>
  );
};

export default GroupsTableCompany;
